<template>
	<div>
		<el-row class="contents" style="padding-left:10px">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" :rules="rules" ref="queryParams" class="form" size="small" label-width="80px">
					<el-form-item label="选择变量" prop="variables">
						<el-select multiple v-model="queryParams.variables" filterable remote reserve-keyword placeholder="请选择变量" :remote-method="queryTemplateVariableList"
							:loading="templateVariableLoading" @visible-change="templateVariableSelectFocus" :clearable="true" collapse-tags :multiple-limit="10">
							<el-option v-for="item in templateVariableList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="日期范围" prop="createDates">
						<el-date-picker ref="dateRangePicker" v-model="queryParams.createDates" :type="datePickerType" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期" align="right" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="handleDateLimitChange">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="search">查询</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<el-card class="chart-container">
				<div slot="header" class="clearfix">
					<span>曲线趋势图</span>
				</div>
				<div>
					<el-empty description="暂无数据" style="width: 100%; height: 500px" v-if="!chartOptions.series"></el-empty>
					<div ref="chart" style="width: 100%; height: 500px" v-show="chartOptions.series"></div>
				</div>
			</el-card>


			<el-col :span="24" v-if="!searchLoading">
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
					<el-tab-pane label="多变量模式" name="multiple">
						<el-table v-loading="loading" :data="multipleList" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark">
							<el-table-column prop="createTime" label="更新时间"></el-table-column>
							<el-table-column :prop="variable.id" :label="variable.title" :key="variable.id" v-for="variable in variableList">
							</el-table-column>
						</el-table>
						<div class="more" v-if="!loading">
							<el-button type="primary" size="small" @click="getMoreList" v-if="queryParams.currentPage<totalPage">查询更多</el-button>
							<span v-else>--没有更多了--</span>
						</div>
					</el-tab-pane>
					<el-tab-pane label="单变量模式" name="single">
						<el-tabs v-model="activeVariableId" type="card" @tab-click="variableClick">
							<el-tab-pane :label="variable.title" :key="variable.id" :name="variable.id" v-for="variable in variableList">
								<el-table v-loading="loading" :data="list" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark"
									@selection-change="handleSelectionChange" @sort-change="sortChange" :default-sort="queryParams.defaultSort">
									<el-table-column prop="variableTitle" label="变量名称"></el-table-column>
									<el-table-column prop="variableValue" label="变量值"></el-table-column>
									<el-table-column prop="createTime" label="更新时间"></el-table-column>
								</el-table>
								<div class="more" v-if="!loading">
									<el-button type="primary" size="small" @click="getMoreList" v-if="queryParams.currentPage<totalPage">查询更多</el-button>
									<span v-else>--没有更多了--</span>
								</div>
							</el-tab-pane>
						</el-tabs>
					</el-tab-pane>
					<el-tab-pane label="异常数据" name="error">
						<el-tabs v-model="activeVariableId" type="card" @tab-click="variableClick">
							<el-tab-pane :label="variable.title" :key="variable.id" :name="variable.id" v-for="variable in variableList">
								<el-table v-loading="loading" :data="list" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark"
									@selection-change="handleSelectionChange" @sort-change="sortChange" :default-sort="queryParams.defaultSort">
									<el-table-column prop="variableTitle" label="变量名称"></el-table-column>
									<el-table-column prop="variableValue" label="变量值"></el-table-column>
									<el-table-column prop="createTime" label="更新时间"></el-table-column>
								</el-table>
								<div class="more" v-if="!loading">
									<el-button type="primary" size="small" @click="getMoreList" v-if="queryParams.currentPage<totalPage">查询更多</el-button>
									<span v-else>--没有更多了--</span>
								</div>
							</el-tab-pane>
						</el-tabs>
					</el-tab-pane>
				</el-tabs>
			</el-col>
			<!-- 列表 -->

		</el-row>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import * as echarts from 'echarts';
	import dateRangeLimitMixin from '@/utils/dateRangeLimitMixin'

	export default {
		props: ['templateId', 'deviceId', 'variableId', 'variableTitle'],
		extends: BaseSearch,
		mixins: [dateRangeLimitMixin],
		data() {
			return {
				datePickerType: 'datetimerange',
				queryParams:{
					variables:[],
					createDates:[]
				},
				rules: {
					variables: [{
						required: true,
						message: '请选择变量',
						trigger: 'blur',
						validator: this.checkArrayNotEmpty
					}, ],
					createDates: [{
						required: true,
						message: '请选择日期范围',
						trigger: 'blur',
						validator: this.checkArrayNotEmpty
					}],
				},
				url: 'template/variable/value/log',
				name: '变量历史记录',
				activeName: 'first',
				// pickerOptions: {
				// 	shortcuts: [{
				// 		text: '最近30分钟',
				// 		onClick(picker) {
				// 			const end = new Date();
				// 			const start = new Date();
				// 			start.setTime(start.getTime() - 1800 * 1000);
				// 			picker.$emit('pick', [start, end]);
				// 		}
				// 	}, {
				// 		text: '最近2小时',
				// 		onClick(picker) {
				// 			const end = new Date();
				// 			const start = new Date();
				// 			start.setTime(start.getTime() - 3600 * 1000 * 2);
				// 			picker.$emit('pick', [start, end]);
				// 		}
				// 	}, {
				// 		text: '最近一天',
				// 		onClick(picker) {
				// 			const end = new Date();
				// 			const start = new Date();
				// 			start.setTime(start.getTime() - 3600 * 1000 * 24);
				// 			picker.$emit('pick', [start, end]);
				// 		}
				// 	}],
				// 	disabledDate(time) {
				// 		const now = new Date();
				// 		const thirtyDaysAgo = new Date(now.getTime() - 180 * 24 * 60 * 60 * 1000); // 30天前
				// 		return time.getTime() < thirtyDaysAgo.getTime();
				// 	}
				// },
				queryTemplateVariableParams: {
					currentPage: 1,
					pageSize: 3000,
					defaultSort: {}
				},
				dialogTemplateVariableVisible: false,
				templateVariableList: [],
				templateVariableLoading: false,
				variableList: [],
				activeVariableId: null,
				autoQuery: false,
				multipleList: [],
				list: [],
				searchLoading: true,
				chartOptions: {
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						left: 'center', // 居中显示图例
						top: 'top', // 将图例放在底部
						orient: 'horizontal' // 水平排列
					},
					toolbox: {
						feature: {
							dataView: {
								show: !0,
								readOnly: !1
							},
							restore: {
								show: !0
							},
							saveAsImage: {
								show: !0
							}
						},
						right: "2%"
					},
					xAxis: {
						type: 'time', // X轴为时间类型
						boundaryGap: false
					},
					yAxis: {
						type: 'value',
						boundaryGap: [0, '100%']
					},
					dataZoom: [{
							type: 'inside',
							start: 0,
							end: 100
						},
						{
							start: 0,
							end: 100
						}
					],
					grid: {
						left: "60px",
						right: "60px"
					},
					series: null,
					myChart:null
				}
			};
		},
		created() {
			// 设置字段路径和可配置月份
			const myShortcuts = {
				shortcuts: [{
					text: '最近30分钟',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 1800 * 1000);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近2小时',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 2);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一天',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24);
						picker.$emit('pick', [start, end]);
					}
				}],
			};
			this.limitMonth = 6; // 半年区间（6个月）
			this.initDateLimitMixin('queryParams.createDates', myShortcuts);
		},
		filters: {},
		methods: {
			checkArrayNotEmpty(rule, value, callback) {
				value =this.queryParams[rule.field]
				if (value && value.length > 0) {
					callback();
				} else {
					callback(new Error(rule.message));
				}
			},
			setDefaultTimeRange() {
				const now = new Date(); // 当前时间
				const twoHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000); // 前两个小时
				const startTime = this.formatDate(twoHoursAgo);
				const endTime = this.formatDate(now);
				this.queryParams.createDates = [startTime, endTime];
				this.$forceUpdate(); // 强制更新组件
			},
			formatDate(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {};
				}
			},
			handleClick(tab, event) {
				this.datas = []
				this.activeVariableId = this.queryParams.variables[0]
				this.handleQuery()
			},
			templateVariableSelectFocus(show) {
				if(show){
					this.queryTemplateVariableList()
				}
			},
			queryTemplateVariableList(query) {
				let that = this;
				this.queryTemplateVariableParams.title = query;
				if (this.templateId) {
					this.templateVariableLoading = true;
					this.queryTemplateVariableParams.templateId = this.templateId;
					this.$http({
						method: 'POST',
						url: 'template/variable/query',
						data: this.queryTemplateVariableParams,
					}).then(function(res) {
						that.templateVariableList = res.data.data;
						that.templateVariableLoading = false
					})
				} else {
					that.templateVariableList = []
				}
			},
			search() {
				this.$refs['queryParams'].validate(valid => {
					if (valid) {
						this.searchLoading = false
						this.activeName = "multiple"
						this.$http({
							method: 'POST',
							url: 'template/variable/queryTitle',
							data: this.queryParams.variables,
						}).then((res) => {
							this.variableList = res.data.data;
							this.activeVariableId = this.queryParams.variables[0]
							this.queryParams.deviceId = this.deviceId
							this.queryDatas()
							this.handleQuery()
						})
					} else {
						return false;
					}
				});
				
				
			},
			getMoreList() {
				this.queryParams.currentPage = this.queryParams.currentPage + 1;
				this.getList()
			},
			variableClick(tab, event) {
				this.datas = []
				this.queryParams.variableId = tab.name
				this.handleQuery();

			},
			getSeriesData(datas) {
				return datas.map(item => {
					return {
						name: item.title, // 曲线名称
						type: 'line', // 曲线类型
						smooth: true, // 平滑曲线
						data: item.list ? item.list.map(dataPoint => [parseInt(dataPoint.time), parseFloat(dataPoint.value)]) : [] // 格式化时间和值
					};
				});
			},
			queryDatas() {
				const params = JSON.parse(JSON.stringify(this.queryParams));
				params.status = 1
				params.variableIds = this.queryParams.variables
				this.$http({
					method: 'POST',
					url: 'template/variable/value/log/queryDatas',
					data: params,
				}).then((res) => {
					if (res.data.data) {
						this.chartOptions.series = this.getSeriesData(res.data.data)
					} else {
						this.chartOptions.series = null
					}
					this.$nextTick(() => {
						if(!this.myChart){
							var chartDom = this.$refs.chart;
							this.myChart = echarts.init(chartDom);
						}
						console.log(JSON.stringify(this.chartOptions));
						this.myChart.setOption(this.chartOptions, { notMerge: true });
						this.myChart.resize();
					});

				})
			},
			beforeQuery() {
				if (this.activeName == "multiple") {
					//多选
					this.queryParams.status = 1
					this.queryParams.variableIds = this.queryParams.variables
					this.queryParams.variableId = null
					this.queryUrl = "/queryMultiple"
					if (this.queryParams.currentPage == 1) {
						this.multipleList = []
					}
				} else if (this.activeName == "single") {
					//单选
					this.queryParams.status = 1
					this.queryParams.variableIds = null
					this.queryParams.variableId = this.activeVariableId
					this.queryUrl = "/query"
					if (this.queryParams.currentPage == 1) {
						this.list = []
					}
				} else if (this.activeName == "error") {
					//异常
					this.queryParams.status = 2
					this.queryUrl = "/query"
					this.queryParams.variableIds = null
					this.queryParams.variableId = this.activeVariableId
					if (this.queryParams.currentPage == 1) {
						this.list = []
					}
				}
			},
			beforeList(list) {
				if (list) {
					if (this.activeName == "multiple") {
						list.forEach((data, dataIndex) => {
							var value = {
								createTime: data.createTime
							}
							data.variableValueLogs.forEach((log, index) => {
								if (log) {
									value[this.variableList[index].id] = log
								} else {
									value[this.variableList[index].id] = "-"
								}
							})
							this.multipleList.push(value)
						})
					} else {
						list.forEach((data, dataIndex) => {
							this.list.push(data)
						})
					}
				}
			}
		},
		mounted: function() {
			if (this.variableId) {
				this.queryParams.variables = [this.variableId]
				this.templateVariableList = [{
					id: this.variableId,
					title: this.variableTitle
				}]
			}
			this.setDefaultTimeRange()
			if (this.variableId) {
				this.search();
			}
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	.el-date-editor {
		width: 400px;

		input {
			width: 148px !important;
		}
	}

	.form {
		margin-left: 0px;
		margin-bottom: 0px;
	}

	.more {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 60px;
	}

	.chart-container {
		min-width: 800px;
	}

	/deep/ .el-card__body,
	.el-main {
		padding: 0px !important;
	}

	/deep/ .el-date-editor.el-input__inner,
	.handleQuery .el-date-editor.el-input {
		width: 380px !important;
		;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/log/templateVariableValueLog.vue